<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const equipmentTypeOptions = [
        `Matériel industriel`,
        `Matériel domestique`,
        `Électricité solaire`,
        `Matériel de sécurité`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const purchaseObjectiveOptions = [
        `Installation neuve`,
        `Rénovation`,
        `Maintenance`,
        `Amélioration de l'efficacité énergétique`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const quantityOptions = [
        `Petite quantité pour usage personnel`,
        `Quantité moyenne pour un projet spécifique`,
        `Grande quantité pour un projet industriel ou commercial`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const technicalAssistanceOptions = [
        `Oui, pour le choix du matériel`,
        `Oui, pour l'installation`,
        `Non, je suis autonome`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.materielElectrique.equipmentType}
        class=""
        let:field
        let:id
        label={`Quel type de matériel électrique recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={equipmentTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielElectrique.purchaseObjective}
        class=""
        let:field
        let:id
        label={`Quel est votre principal objectif d'achat ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={purchaseObjectiveOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielElectrique.quantity}
        class=""
        let:field
        let:id
        label={`Quel est le volume ou la quantité de matériel dont vous avez besoin ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={quantityOptions}
            placeholder="Sélectionnez une quantité"
        />
    </Row>

    <Row
        {form}
        field={fields.materielElectrique.technicalAssistance}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin de conseils ou d'une assistance technique pour votre projet ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={technicalAssistanceOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
